module.exports = __webpack_public_path__ + "img/decoration.4fd76e9f.svg";